import merge from 'lodash/merge'

export default {
  //
  //Widget
  //
  notifyByEmail(state) {

    const online = state.widget.onlineAgentsList
    const options = state.widget.options
    return (!online &&
      options.destination) ||
      (online &&
        options.online_form.notify_by_email)

  },
  isOnline(state) {
    return state.widget ? state.widget.onlineAgentsList : false
  },
  isHideOffline(state) {
    return state.widget ? state.widget.options.offline_form.hideoffline : false
  },
  getLang(state) {
    //console.log(state.defaultLang, state.tempLang)
    return state.widget ? merge({}, state.defaultLang, state.widget.language) : {}
  },
  getSettings(state) {
    return state.widget && state.widget.settings ? state.widget.settings : {}
  },
  notifyInstall(state) {
    return state.widget && state.widget['.key'] && !state.widget.first_install ? true : false
  },
  getWidgetName(state) {
    return state.widget ? state.widget.name : ''
  },
  getTeams(state) {
    const teams = []
    const team_ids = state.widget ? state.widget.teams : {}

    if (!state.teams)
      return teams

    for (var i in team_ids)
      if (state.teams[i])
        teams.push({
          value: i,
          label: state.teams[i].name
        })

    return teams
  },
}
